export const now = () => {
    return (new Date).toLocaleTimeString()
}

export const today = () => {
    return (new Date).toLocaleDateString()
}
